// extracted by mini-css-extract-plugin
module.exports = {"ColumnAdd":"ColumnAdd-module__ColumnAdd___3sCZc","last":"ColumnAdd-module__last___19pSq","text":"ColumnAdd-module__text___3gRGz"};